import React                               from 'react';
import {StyledDocsHint, StyledHintWrapper, StyledRedHintWrapper} from "./styles";
import Button                              from "../button";
import {useWindowWidth}                    from "@react-hook/window-size";
import {Modal}                             from "../modal";
import {Text4}                             from "../globalStyles";
import {QuestionIcon} from "../../../icons/ui/Question";
import {RedWarningIcon} from "../../../icons/ui/RedWarning";

export type HintProps = {
  text?: string | null
}

const RedHint: React.FC<HintProps> = (props) => {
  const windowWidth = useWindowWidth({wait: 300});
  const {text} = props;
  const [stateIsLeft, setIsLeft] = React.useState<boolean>(false);
  const [stateModalIsOpen, setModalIsOpen] = React.useState<boolean>(false);
  const hintRef = React.useRef<HTMLButtonElement | null>(null);

  React.useEffect(() => {
    if (!hintRef.current) return;
    const rect = hintRef.current.getBoundingClientRect();
    if (rect.left < (window.innerWidth / 2)) return setIsLeft(true);
  }, [])

  const openModalHandler = (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();
    if (windowWidth > 767) return;
    setModalIsOpen(true);
  };

  const closeModalHandler = () => setModalIsOpen(false);

  if (!text) return null;

  return (
    <StyledRedHintWrapper className="hintWrapper">
      <Button ref={hintRef} onClick={openModalHandler} appearance="icon" icon={<RedWarningIcon/>}/>
      <Modal header=" " onClose={closeModalHandler} isOpen={stateModalIsOpen}>
        <Text4>{text}</Text4>
      </Modal>

      <StyledDocsHint className="doc-hint" isLeft={stateIsLeft}>
        {text}
      </StyledDocsHint>
    </StyledRedHintWrapper>
  );
};

export default RedHint;